<template>
  <UiTable
    class="ui-stats-organization-table"
    :data="organizations"
    :columns="columnDefs"
    :is-striped="true"
  >
    <template #column-name="{ row }">
      <BaseLink :to="'/organization/' + row.id" icon-size="size-7">{{
        ls(row.name)
      }}</BaseLink>
    </template>
    <template #column-url="{ row }">
      <BaseLink :to="row.url" icon-size="size-7">{{ row.url }}</BaseLink>
    </template>
  </UiTable>
</template>

<script lang="ts" setup>
import type { ColumnDef } from '~/components/ui/UiTable.vue'

const { ls, lss } = useI18n()

interface Props {
  organizations: Organization[]
}
const props = withDefaults(defineProps<Props>(), {})

const columnDefs: ColumnDef[] = [
  {
    label: () => lss('機関名', 'Name'),
    path: ['name'],
    class: 'jps-srt-name',
    key: 'name',
  },
  {
    label: () => lss('連携機関のHP', "Organization's Homepage"),
    class: 'jps-srt-name',
    key: 'url',
  },
]
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-stats-organization-table {
  font-size: $size-8;
  max-width: 1000px;
  margin: 0 auto;
}
</style>
